import { MapDataSourceId } from "../models/MapDataSource";
import { IDataExtractor } from './abstractions/IDataExtractor';


export class MapDataExtractorProvider {
  private _extractors = new Map<MapDataSourceId, IDataExtractor>();

  register(dataSourceId: MapDataSourceId, extractor: IDataExtractor) {
    this._extractors.set(dataSourceId, extractor);
  }

  resolve(dataSourceId: MapDataSourceId) {
    if (!this._extractors.has(dataSourceId)) {
      throw new Error(`${dataSourceId} extractor is not registered`);
    }
    return this._extractors.get(dataSourceId)!;
  }
}